import { CalendarEvent } from 'angular-calendar';

import { createAction } from '../../../store.model';
import { CommitmentSummaryItem } from '../commitment-summary-item.model';
import { ScheduleEvent } from '../models/schedule-event.model';
import { ScheduleItem } from '../models/schedule.model';

import { ScheduleEventFormValue } from './schedule-event.form';

export enum ActionType {
    SCHEDULE__EVENT_CLEAR = 'SCHEDULE__EVENT_CLEAR',
    SCHEDULE__EVENT_RETRIEVE_COMMITMENTS = 'SCHEDULE__EVENT_RETRIEVE_COMMITMENTS',
    SCHEDULE__EVENT_RETRIEVE_COMMITMENTS_RESULT = 'SCHEDULE__EVENT_RETRIEVE_COMMITMENTS_RESULT',
    SCHEDULE__EVENT_RETRIEVE_EVENTS = 'SCHEDULE__EVENT_RETRIEVE_EVENTS',
    SCHEDULE__EVENT_RETRIEVE_EVENTS_RESULT = 'SCHEDULE__EVENT_RETRIEVE_EVENTS_RESULT',
    SCHEDULE__EVENT_SAVE = 'SCHEDULE__EVENT_SAVE',
    SCHEDULE__EVENT_SAVE_RESULT = 'SCHEDULE__EVENT_SAVE_RESULT',
    SCHEDULE__EVENT_INIT_RETRIEVE_EVENT = 'SCHEDULE__EVENT_INIT_RETRIEVE_EVENT',
    SCHEDULE__EVENT__RETRIEVE_EVENT_RESULT = 'SCHEDULE__EVENT__RETRIEVE_EVENT_RESULT',
    SCHEDULE__EVENT_UPDATE = 'SCHEDULE__EVENT_UPDATE',
    SCHEDULE__EVENT_UPDATE_RESULT = 'SCHEDULE__EVENT_UPDATE_RESULT',
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ScheduleEventClearAction {}

export const scheduleEventClear = createAction<
    ActionType,
    ScheduleEventClearAction
>(ActionType.SCHEDULE__EVENT_CLEAR);

/// //////////////////////

export interface RetrieveCommitmentsAction {
    userId: number;
}

export const retrieveCommitments = createAction<
    ActionType,
    RetrieveCommitmentsAction
>(ActionType.SCHEDULE__EVENT_RETRIEVE_COMMITMENTS);

export interface RetrieveCommitmentsResultAction
    extends RetrieveCommitmentsAction {
    commitments: CommitmentSummaryItem[];
}

export const retrieveCommitmentResult = createAction<
    ActionType,
    RetrieveCommitmentsResultAction
>(ActionType.SCHEDULE__EVENT_RETRIEVE_COMMITMENTS_RESULT);

/// //////////////////////

export interface RetrieveEventsAction {
    userId: number;
    startDate: Date;
}

export const retrieveEvents = createAction<ActionType, RetrieveEventsAction>(
    ActionType.SCHEDULE__EVENT_RETRIEVE_EVENTS,
);

export interface RetrieveEventsResultAction extends RetrieveEventsAction {
    calendarEvents: Array<CalendarEvent<ScheduleItem>>;
}

export const retrieveEventsResult = createAction<
    ActionType,
    RetrieveEventsResultAction
>(ActionType.SCHEDULE__EVENT_RETRIEVE_EVENTS_RESULT);

/// //////////////////////

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface SaveAction {}

export const save = createAction<ActionType, SaveAction>(
    ActionType.SCHEDULE__EVENT_SAVE,
);

export interface SaveResultAction extends SaveAction {
    event?: ScheduleEvent;
}

export const saveResult = createAction<ActionType, SaveResultAction>(
    ActionType.SCHEDULE__EVENT_SAVE_RESULT,
);

/// //////////////////////

export interface InitRetrieveEventAction {
    eventId: number;
}

export const initRetrieveEvent = createAction<
    ActionType,
    InitRetrieveEventAction
>(ActionType.SCHEDULE__EVENT_INIT_RETRIEVE_EVENT);

export interface RetrieveEventAction {
    updateEvent: ScheduleEvent;
    scheduleEventFormValue: ScheduleEventFormValue;
}

export const retrieveEvent = createAction<ActionType, RetrieveEventAction>(
    ActionType.SCHEDULE__EVENT__RETRIEVE_EVENT_RESULT,
);

/// //////////////////////

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface UpdateAction {}

export const update = createAction<ActionType, UpdateAction>(
    ActionType.SCHEDULE__EVENT_UPDATE,
);

export interface UpdateResultAction extends UpdateAction {
    event?: ScheduleEvent;
}

export const updateResult = createAction<ActionType, UpdateResultAction>(
    ActionType.SCHEDULE__EVENT_UPDATE_RESULT,
);
